import axios from "@/axios";

const state = {
  users: [],
};

const getters = {
  allUsersData: (state) => state.users,

  getUsers: (state) => (id) => {
    return state.users.find((user) => user.id === id);
  },
};

const actions = {
  async fetchUsers({ commit }) {
    const response = await axios.get("/admin/user");
    commit("SET_USERS", response.data);
  },

  async createUser({ dispatch }, info) {
    const response = await axios.post("/admin/user", info);
    await dispatch("fetchUsers");
    return response.data;
  },

  async changePassword(_, info) {
    const response = await axios.post("/auth/resetPassword", info);

    if (response.data.message == "updated") {
      return "updated";
    } else return "failed";
  },
};

const mutations = {
  SET_USERS: (state, users) => (state.users = users),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
